import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import { boatKeys } from "../query-keys";
import type { BoatId } from "@/types/identifiers";

export { boatKeys } from "../query-keys";

export function useBoat(boatId: BoatId) {
  return useQuery({
    queryKey: boatKeys.detail(boatId),
    queryFn: async () => {
      const result = await api.GET("/api/boats/{boat_id}", {
        params: { path: { boat_id: boatId } },
      });
      return throwIfError(result, "Failed to fetch boat");
    },
    enabled: !!boatId,
  });
}

export function useBoats() {
  return useQuery({
    queryKey: boatKeys.list(),
    queryFn: async () => {
      const result = await api.GET("/api/boats", {});
      return throwIfError(result, "Failed to fetch boats");
    },
  });
}
